export const extractTextFromHtml = (html: string): string => {
  if (!html) return "";

  if (globalThis.window !== undefined && typeof DOMParser !== "undefined") {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, "text/html");
  return doc.body.textContent
    ?.replaceAll("\u00A0", "")
    .trim() ?? "";
  }

  return "";
};
